import { IBaseComponentProps } from "../props/IBaseComponentProps";

export interface NSSpaceProps extends IBaseComponentProps
{
	size: NSSpaceSizeType;
}

export enum NSSpaceSizeType
{
	NANO = "4px",
	MICRO = "8px",
	MINI = "16px",
	SMALL = "24px",
	MEDUIM = "32px",
	NORMAL = "48px",
	LARGE = "64px",
	XLARGE = "80px",
	XXLARGE = "96px",
	XXXLARGE = "128px",
}

export function NSSpace(props: NSSpaceProps)
{
	return (
		<hr id={props.id}
			className={props.classList?.join(" ") ?? ""}
			style={{ ...props.style, width: "100%", height: props.size, margin: "0px", padding: "0px", background: "transparent", color: "transparent", border: 0, position: "relative", zIndex: -1 }} />
	);
}